export default __webpack_public_path__ + "static/TRANS-CER-f1e4a2fcccff4c0deced30398de48d5c.webp";